const DEFAULT_LOCALE = 'en-GB'

/**
 * Normalize request language to a supported locale folder name.
 * en / en-* → en-GB, de / de-* → de-DE, zh / zh-* → zh-CN. Else → en-GB.
 */
export function normalizeMachineryDirectiveRiskAssessmentLocale(
  lang: string | undefined
): string {
  if (!lang || typeof lang !== 'string') {
    return DEFAULT_LOCALE
  }
  const normalized = lang.trim().toLowerCase()
  if (normalized.startsWith('en')) {
    return 'en-GB'
  }
  if (normalized.startsWith('de')) {
    return 'de-DE'
  }
  if (normalized.startsWith('zh')) {
    return 'zh-CN'
  }
  return DEFAULT_LOCALE
}

/** Same normalization rules as risk assessment locales. */
export function normalizeInstructionHandbookLocale(
  lang: string | undefined
): string {
  return normalizeMachineryDirectiveRiskAssessmentLocale(lang)
}

export const COMPLIANCE_DOCUMENTS_DEFAULT_LOCALE = DEFAULT_LOCALE

export type ComplianceDocumentsLocaleKey = 'en-GB' | 'de-DE' | 'zh-CN'

/** Map i18next-style language tag to a supported compliance-documents locale. */
export function normalizeComplianceDocumentsUiLocale(
  i18nLanguage: string | undefined
): ComplianceDocumentsLocaleKey {
  const normalized = normalizeMachineryDirectiveRiskAssessmentLocale(
    i18nLanguage
  )
  if (normalized === 'de-DE' || normalized === 'zh-CN') {
    return normalized
  }
  return 'en-GB'
}
